import { apiFetch, apiFetchLong } from './api';

export function getFormations(params = {}) {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== '')
  ).toString();

  return apiFetch(`/formations${query ? `?${query}` : ''}`);
}

export function getFormationById(id) {
  return apiFetch(`/formations/${id}`);
}

export function createFormation(data) {
  return apiFetch('/formations', { method: 'POST', body: JSON.stringify(data) });
}

export function updateFormation(id, data) {
  return apiFetch(`/formations/${id}`, { method: 'PUT', body: JSON.stringify(data) });
}

/** Analyse un texte de catalogue collé : renvoie des propositions de formations. */
/** Le texte du catalogue public d'echo-cse.fr : { url, texte, caracteres }. */
export function texteCatalogueSite() {
  return apiFetch('/formations/import/site-texte');
}

/** Le catalogue public lu tel quel (sans IA) : { propositions, meta }. */
export function analyserImportFormationsSite() {
  return apiFetch('/formations/import/site', { method: 'POST' });
}

/** Supprime une sélection de formations, sessions du calendrier comprises. */
export function supprimerFormations(ids) {
  return apiFetch('/formations/supprimer', { method: 'POST', body: JSON.stringify({ ids }) });
}

/** Vide le catalogue avant un import complet, sessions du calendrier comprises. */
export function supprimerToutesFormations() {
  return apiFetch('/formations/tout', { method: 'DELETE' });
}

export function analyserImportFormations(texte) {
  return apiFetchLong('/formations/import/analyser', {
    method: 'POST',
    body: JSON.stringify({ texte }),
  });
}

/** Crée ou met à jour les formations retenues après relecture. */
export function enregistrerImportFormations(formations) {
  return apiFetch('/formations/import/enregistrer', {
    method: 'POST',
    body: JSON.stringify({ formations }),
  });
}

export function deleteFormation(id) {
  return apiFetch(`/formations/${id}`, { method: 'DELETE' });
}
